module.exports = __webpack_public_path__ + "img/27.1b71bab7.jpg";